import type { pairing as pairingEn } from '../en/pairing';

export const pairing: typeof pairingEn = {
  intro:
    'Conecte el teléfono de su pareja para que las tomas, los pañales y todo lo demás aparezcan en ambos teléfonos automáticamente.',
  createInvite: 'Crear invitación',
  creating: 'Creando invitación…',

  inviteTitle: 'Su código de invitación',
  showInvite: 'Mostrar código de invitación',
  hideInvite: 'Ocultar código de invitación',
  scanHint: 'En el teléfono de su pareja, escanee esto con la cámara, o escriba el código durante la configuración.',
  keyWarning:
    'Este código es también la llave que protege sus datos. Compártalo directamente con su pareja y con nadie más.',
  shareLink: 'Compartir enlace de invitación',
  copyLink: 'Copiar enlace de invitación',
  copied: '¡Enlace copiado!',
  qrAlt: 'Código de invitación en formato QR',

  enterHint: 'Pídale a mamá que abra Configuración, luego Conexión con su pareja, y toque Crear invitación.',
  codeLabel: 'Código de invitación',
  codePlaceholder: 'XXXX-XXXX-XXXX-XXXX',
  connect: 'Conectar',
  connecting: 'Conectando…',

  connectedSince: (date: string) => `Conectados desde el ${date}`,
  syncNow: 'Sincronizar ahora',
  disconnect: 'Desconectar',
  disconnectWarning:
    'La sincronización se detendrá, pero no se borra nada. Todos los registros se quedan en ambos teléfonos.',
  confirmDisconnect: 'Sí, desconectar',

  errors: {
    invalidCode: 'Ese código no parece completo. Tiene 16 letras y números.',
    unreachable: 'No pudimos conectar con el servicio de sincronización. Revise su conexión a internet e intente de nuevo.',
    joinFailed: 'Eso no funcionó. Revise bien el código e intente de nuevo.',
    createFailed: 'No pudimos crear la invitación. Revise su conexión a internet e intente de nuevo.',
  },
};
